  export const holidays2025 = [
    { date: "2025-01-26", name: "Republic Day" },
    { date: "2025-02-26", name: "Maha Shivaratri" },
    { date: "2025-03-14", name: "Holi" },
    { date: "2025-03-31", name: "Id-ul-Fitr" },
    { date: "2025-04-10", name: "Mahavir Jayanti" },
    { date: "2025-04-18", name: "Good Friday" },
    { date: "2025-05-12", name: "Buddha Purnima" },
    { date: "2025-06-07", name: "Bakrid" },
    { date: "2025-07-06", name: "Muharram" },
    { date: "2025-08-15", name: "Independence Day" },
    { date: "2025-08-27", name: "Ganesh Chaturthi" },
    { date: "2025-09-05", name: "Milad-un-Nabi" },
    { date: "2025-10-02", name: "Gandhi Jayanti / Vijaya Dashami" },
    { date: "2025-10-20", name: "Diwali" },
    { date: "2025-11-05", name: "Guru Nanak Jayanti" },
    { date: "2025-12-25", name: "Christmas" },
  ];

  export const academicsMonsoon2025 = [
    { date: "2025-07-23", name: "Reporting and Registration of New students" },
    { date: "2025-07-23", name: "Orientation for new students" },
    { date: "2025-07-25", name: "Academic Registration for New students" },
    { date: "2025-07-25", name: "Registration for old students" },
    { date: "2025-07-26", name: "Last date of Late Registration with fine" },
    { date: "2025-07-28", name: "Commencement of classes" },
    { date: "2025-07-28", name: "Add and Drop of Courses" },
    { date: "2025-09-19", name: "Mid-semester Examinations" },
    { date: "2025-10-03", name: "Last date to share marks of Mid-semester exams" },
    { date: "2025-10-27", name: "Mid-Semester break" },
    { date: "2025-11-17", name: "Pre-registration for next semester" },
    { date: "2025-11-25", name: "Last teaching day" },
    { date: "2025-11-26", name: "End-semester Examinations" },
    { date: "2025-11-26", name: "Research Seminar" },
    { date: "2025-12-04", name: "Grades to be submitted online on the Portal" },
    { date: "2025-12-04", name: "Vacation (Only for BTech and MSc students)" },
    { date: "2025-12-11", name: "Vacation (Only for MTech and PhD students)" },
    { date: "2025-12-12", name: "Last date for submission of PhD/MTech Thesis grades" },
    { date: "2025-12-23", name: "Supplementary Examination" },
    { date: "2025-12-29", name: "Registration for next semester" },
  ]